import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "@/lib/data";

export default function Testimonials() {
  return (
    <section data-testid="testimonials-section" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl mb-14">
          <span className="eyebrow">Client Stories</span>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl mt-4 text-[#041047] tracking-tight leading-[1.1]">
            Trusted by founders who <em className="italic font-medium">demand results</em>.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {TESTIMONIALS.map((t, i) => (
            <div
              key={t.name}
              data-testid={`testimonial-${i}`}
              className="ddn-card relative"
            >
              <Quote className="w-7 h-7 text-[#D4AF37] mb-5" />
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, k) => (
                  <Star key={k} className="w-4 h-4 fill-[#D4AF37] text-[#D4AF37]" />
                ))}
              </div>
              <p className="text-[#041047] text-[1.02rem] leading-relaxed mb-7">
                “{t.quote}”
              </p>
              <div className="flex items-center gap-4 mt-auto pt-4 border-t border-[#041047]/10 w-full">
                <img
                  src={t.img}
                  alt={t.name}
                  className="w-12 h-12 object-cover rounded-full"
                  loading="lazy"
                />
                <div>
                  <div className="font-semibold text-[#041047]">{t.name}</div>
                  <div className="text-sm text-[#475569]">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
